import { useState, useEffect } from 'react'
import { useLocalStorageState } from 'ahooks'

interface Props {
  id: string // localstorage存储的唯一id
  rawColumns: any[] // 原始字段完整版，不包含action
  disabledKeys: string[] // 无法自定义调整的字段
}

const useCustomField = ({ id, rawColumns, disabledKeys }: Props) => {
  const defaultColumns = rawColumns
    .filter((field) => !disabledKeys.includes(field.dataIndex))
    .map((field) => {
      return { ...field, isSelected: true }
    })
  const [customFields, setCustomFields] = useState<any[]>(defaultColumns)
  const [localColumns, setLocalColumns] = useLocalStorageState<any[]>(id, {
    defaultValue: []
  })
  useEffect(() => {
    if (localColumns?.length > 0) {
      const newList = localColumns
        .map((l) => {
          return {
            dataIndex: l.dataIndex,
            isSelected: l.isSelected,
            title: rawColumns.find((i) => i.dataIndex === l.dataIndex)?.title,
            render: rawColumns.find((i) => i.dataIndex === l.dataIndex)?.render
          }
        })
        .filter((item) => item.isSelected === true)
      setCustomFields(newList)
    }
  }, [rawColumns])

  return {
    defaultColumns,
    customFields,
    setCustomFields
  }
}

export default useCustomField
